import {
	IconButton,
	Sidebar,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Customer/Customer.module.scss';
import Avatar from '../../assets/img/Mima-avatar.png';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { Formik } from 'formik';
import { nanoid } from 'nanoid';
import React from 'react';

const ViewCustomer = ({
	closeModal,
	showCustomerViewMenu,
	customerViewMenu,
	goToEditCustomer,
}) => {
	return (
		<Modal closeModal={closeModal}>
			<div className={styles.view}>
				<div className={styles.view_menu} onClick={showCustomerViewMenu}>
					<BsThreeDotsVertical />
				</div>
				{customerViewMenu && (
					<div className={`${styles.customerMenu} ${styles.view_customerMenu}`}>
						<ul>
							<li onClick={goToEditCustomer}>Edit</li>
							<li>Delete</li>
							<li>Send Invoice</li>
							<li>Send Receipt</li>
							<li>Add Note</li>
						</ul>
					</div>
				)}
			</div>
			<div className={styles.customer__avatar_container}>
				<img
					src={Avatar}
					alt="Customer image"
					className={styles.customer__avatar}
				/>
			</div>
			<MimaText variant="subtitle" color="var(--color-primary)" align="center">
				Bola Adebayo
			</MimaText>
			<div className={styles.view_content}>
				<MimaText labelTitle="Phone Number" mb={2}>
					+234 809 9887 755
				</MimaText>
				<MimaText labelTitle="Email Address" mb={2}>
					bolaadebayo@gmail.com
				</MimaText>
				<MimaText labelTitle="Gender" mb={2}>
					Female
				</MimaText>
				<MimaText labelTitle="Delivery Address" mb={2}>
					21, xyz close, Ikeja, Lagos
				</MimaText>
				<MimaText labelTitle="Note">She doesn’t like the color Black.</MimaText>
			</div>
		</Modal>
	);
};

export default ViewCustomer;
